import React from 'react';
import AZmedNavbar from '../AZmedNavBar/AZmedNavbar';
import './StudyView.css';

//#region COMPONENT
/**
 * @returns
 */
const StudyView = props => {
  //#region INITIALIZATION
  const { children } = props;
  // #endregion

  // #region INTERFACE
  return (
    <>
      <div style={{ zIndex: 1 }}>
        <AZmedNavbar />
      </div>
      <div className="StudyView-root" style={{ display: 'flex' }}>
        {children}
      </div>
    </>
  );
  //#endregion
};
//#endregion

export default StudyView;
